import Button from "@mui/material/Button";
import { useTranslation } from "react-i18next";
import { useMutation } from "@tanstack/react-query";
import { useContext } from "react";
import { GlobalContext } from "../../../../util/state/GlobalContextProvider";
import { IDownloadExpiredPracticeFileReturn } from "../../models/models";
import { createFile } from "../../utils";
import { setSnackbar } from "../../../../util/state/globalAction";
import { snackbarTypes } from "../../../../util/state/globalVariables";
import CustomLoader from "../../../../util/component/CustomLoader";
import { downloadPivot } from "../../services/http.services";
import { FileType } from "../../config";

const PivotButton = () => {
    const {t} = useTranslation("expiredManagement");

    const { dispatchGlobalData } = useContext(GlobalContext);

    const downloadPivotMutation = useMutation({
        mutationFn: () => {
            return downloadPivot();
        },
        onSuccess: (data: IDownloadExpiredPracticeFileReturn) => {
            createFile(data.file, data.fileName, FileType.XLSX);
        },
        onError: (err) => {
            dispatchGlobalData({
                type: setSnackbar,
                payload: {
                    snackbar: {
                        message: t('translation:error.tryLater'),
                        type: snackbarTypes.error,
                        show: true,
                        autoClose: true,
                    }
                }
            });
        }

    });

    return(
        <>
            <Button onClick={() => downloadPivotMutation.mutate()}>
                {t("Pivot")}
            </Button>

            <CustomLoader loading={downloadPivotMutation.isLoading}/>
        </>
    )

}

export default PivotButton;